
import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { Textarea } from '@/components/ui/textarea';
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import { ApplicationFormData } from './ApplicationFormSchema';

interface MotivationFieldProps {
  form: UseFormReturn<ApplicationFormData>;
}

const MotivationField = ({ form }: MotivationFieldProps) => {
  return (
    <FormField
      control={form.control}
      name="motivation"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Lettre de motivation *</FormLabel>
          <FormControl>
            <Textarea
              placeholder="Parlez-nous de votre motivation à rejoindre Groupe Fabre Environnement..."
              className="min-h-[120px]"
              {...field}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default MotivationField;
